module.exports = __webpack_public_path__ + "img/80.6359afb3.jpg";